(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3852],{

/***/ 93852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ MentionsTextArea_MentionsTextArea; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-mentions/dist/react-mentions.esm.js + 31 modules
var react_mentions_esm = __webpack_require__(88540);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./utils/mentions/index.ts
var mentions = __webpack_require__(29296);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./components/UserAvatar/index.ts + 2 modules
var UserAvatar = __webpack_require__(82957);
// EXTERNAL MODULE: ./components/Mentions/MentionsSuggestion/MentionsSuggestion.module.scss
var MentionsSuggestion_module = __webpack_require__(80078);
var MentionsSuggestion_module_default = /*#__PURE__*/__webpack_require__.n(MentionsSuggestion_module);
;// CONCATENATED MODULE: ./components/Mentions/MentionsSuggestion/MentionsSuggestion.tsx





var cx = bind_default().bind((MentionsSuggestion_module_default()));
var MentionsSuggestion = function(param) {
    var event = param.event, highlightedDisplay = param.highlightedDisplay, index = param.index, isFocused = param.isFocused, isMobileOrTablet = param.isMobileOrTablet, setCurrentlySelected = param.setCurrentlySelected, currentlySelected = param.currentlySelected;
    return(// jsx-a11y plugin requires an OnFocus function because of the onMouseOver
    // Suggestion list elements can't be focused
    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx("mentions-suggestion__container", {
            focused: isFocused === true,
            active: currentlySelected === index,
            mobile: isMobileOrTablet === true
        }),
        "data-qa": "mentions-suggestion__container",
        role: "listitem",
        onMouseDown: function() {
            return setCurrentlySelected(index);
        },
        // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
        onMouseOver: function() {
            return setCurrentlySelected(null);
        },
        onMouseUp: function() {
            return setCurrentlySelected(null);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cx("mentions-suggestion__avatar-container"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                    avatarUrl: event.avatarUrl,
                    className: cx("mentions-suggestion__avatar"),
                    size: "xs",
                    userId: event.id,
                    username: event.display
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cx("mentions-suggestion__user"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("mentions-suggestion__user__name"),
                    children: highlightedDisplay
                })
            })
        ]
    }));
};
/* harmony default export */ var MentionsSuggestion_MentionsSuggestion = (MentionsSuggestion);

;// CONCATENATED MODULE: ./components/Mentions/MentionsSuggestion/index.ts


// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./schema/User/queries.ts
var queries = __webpack_require__(72175);
// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(45578);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
;// CONCATENATED MODULE: ./components/Mentions/MentionsTextArea/helpers/mention-helpers.ts

var mapUserObject = function(userData) {
    var users = userData || [];
    return users.filter(function(userNode) {
        var ref;
        var user = userNode === null || userNode === void 0 ? void 0 : (ref = userNode.node) === null || ref === void 0 ? void 0 : ref.user;
        return (user === null || user === void 0 ? void 0 : user.fullName) && (user === null || user === void 0 ? void 0 : user.id);
    }).map(function(param) {
        var mentionableUser = param.node;
        var ref, ref1, ref2, ref3;
        return {
            display: mentionableUser === null || mentionableUser === void 0 ? void 0 : (ref = mentionableUser.user) === null || ref === void 0 ? void 0 : ref.fullName,
            id: mentionableUser === null || mentionableUser === void 0 ? void 0 : (ref1 = mentionableUser.user) === null || ref1 === void 0 ? void 0 : ref1.id,
            avatarUrl: (mentionableUser === null || mentionableUser === void 0 ? void 0 : (ref2 = mentionableUser.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.profile) === null || ref3 === void 0 ? void 0 : ref3.avatarUrl) || ""
        };
    });
};
var createCombinedSuggestions = function(initial, relevant) {
    var maxSize = 10;
    var combinedList = uniqBy_default()(relevant.concat(initial), "id");
    return combinedList.splice(0, maxSize);
};

;// CONCATENATED MODULE: ./components/Mentions/UsersSearch.tsx











var withUsersSearch = function(BaseComponent) {
    return function WithUsersSearch(_param) {
        var props = (0,_extends/* default */.Z)({}, _param);
        var community = (0,CommunityContext/* useCommunityContext */.v1)().community;
        var handleSearch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(search) {
                var ref, ref1, ref2, variables, res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            variables = {
                                searchTerm: search,
                                communityId: community.id
                            };
                            _ctx.next = 4;
                            return fetchMore({
                                variables: variables
                            });
                        case 4:
                            res = _ctx.sent;
                            return _ctx.abrupt("return", mapUserObject(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.community) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.mentionableUsers) === null || ref2 === void 0 ? void 0 : ref2.edges));
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleSearch(search) {
                return _ref.apply(this, arguments);
            };
        }();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var fetchUsers = function(communityId) {
            // Skip the first load of this query, but establish a fetchMore.
            // This is because of useLazyQuery's lack of return
            // https://github.com/apollographql/react-apollo/issues/3499
            // This query will only be called when the fetchMore is used in the handleSearch function
            var fetchMore = (0,useQuery/* useQuery */.a)(queries/* USERS_QUERY */.Lc, {
                variables: {
                    communityId: communityId
                },
                notifyOnNetworkStatusChange: true,
                skip: true
            }).fetchMore;
            return fetchMore;
        };
        var fetchMore = fetchUsers(community.id);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            handleSearch: handleSearch
        }));
    };
};

/* harmony default export */ var UsersSearch = ((/* unused pure expression or super */ null && (withUsersSearch)));

// EXTERNAL MODULE: ./components/Mentions/MentionsTextArea/MentionsTextArea-x.module.scss
var MentionsTextArea_x_module = __webpack_require__(69690);
var MentionsTextArea_x_module_default = /*#__PURE__*/__webpack_require__.n(MentionsTextArea_x_module);
;// CONCATENATED MODULE: ./components/Mentions/MentionsTextArea/MentionsTextArea.tsx


















var MentionsTextArea_cx = bind_default().bind((MentionsTextArea_x_module_default()));
var container;
var MentionsTextArea = function(param) {
    var id = param.id, additionalClassName = param.additionalClassName, _isPostForm = param.isPostForm, isPostForm = _isPostForm === void 0 ? false : _isPostForm, handleSearch = param.handleSearch, _isExpanded = param.isExpanded, isExpanded = _isExpanded === void 0 ? false : _isExpanded, isModal = param.isModal, onChange = param.onChange, placeholder = param.placeholder, textAreaClassName = param.textAreaClassName, value = param.value, forwardRef = param.forwardRef, _relevantMentions = param.relevantMentions, relevantMentions = _relevantMentions === void 0 ? [] : _relevantMentions, _hasAutoFocus = param.hasAutoFocus, hasAutoFocus = _hasAutoFocus === void 0 ? false : _hasAutoFocus;
    var ref = (0,react.useState)(null), currentlySelected = ref[0], setCurrentlySelected = ref[1];
    var ref1 = (0,react.useState)(document.activeElement), active = ref1[0], setActive = ref1[1];
    var mentionableUsers = (0,CommunityContext/* useCommunityContext */.v1)().mentionableUsers;
    var initialUsers = mapUserObject(mentionableUsers === null || mentionableUsers === void 0 ? void 0 : mentionableUsers.edges);
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var t = (0,es/* useTranslation */.$G)().t;
    var keepTextAreaExpanded = !isModal && currentlySelected !== null;
    var isPhoneScreen = width < constants/* SCREEN_PHONE */.SO;
    var isMobileOrTablet = width < constants/* BREAKPOINT_MD */.GI;
    var inputRef = forwardRef || (0,react.useRef)(null);
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    // postform modal size ( 560px ) - 51(space around either side). There are some resolutions where the
    // the screen is smaller than 560 wide, but we haven't swapped to phone view yet. Pick the smaller of the two numbers.
    var tabletScreenSuggestionListWidth = Math.min(509, width - 51);
    // 17px on either side of postform textArea for phone screens
    var phoneScreenSuggestionListWidth = width - 34;
    var calculatedSuggestionListWidth = isPhoneScreen ? phoneScreenSuggestionListWidth : tabletScreenSuggestionListWidth;
    var leftStyle = isPhoneScreen ? "16px" : null;
    // if not on the postform we want the modal at left:0
    leftStyle = isPostForm ? leftStyle : "0";
    (0,react.useEffect)(function() {
        if ((inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) && hasAutoFocus) {
            inputRef.current.focus();
            setActive(inputRef.current);
        }
    }, [
        inputRef
    ]);
    var combinedUsers = createCombinedSuggestions(initialUsers, relevantMentions);
    // if forwardRef exists, use that, otherwise use inputRef ( comment/reply section modals )
    var mentionsTextAreaRef = forwardRef || inputRef;
    (0,react.useEffect)(function() {
        var ref = mentionsTextAreaRef.current;
        ref === null || ref === void 0 ? void 0 : ref.addEventListener("focusin", handleFocusIn);
        return function() {
            ref === null || ref === void 0 ? void 0 : ref.removeEventListener("focusin", handleFocusIn);
        };
    }, []);
    var handleFocusIn = function() {
        setActive(document.activeElement);
    };
    (0,react.useEffect)(function() {
    // If the user touches a mentions input on any iOS device, scrolling is permanently disabled for the entire app
    // so until we have a better fix for that, don't run any of this code
    // if (active?.nodeName === 'TEXTAREA' && mentionsTextAreaRef && isModal) {
    //   disableBodyScroll(mentionsTextAreaRef.current);
    // } else {
    //   enableBodyScroll(mentionsTextAreaRef.current);
    // }
    }, [
        active
    ]);
    var mentionsSuggestionComponent = function(event, _search, highlightedDisplay, index, focused) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MentionsSuggestion_MentionsSuggestion, {
                currentlySelected: currentlySelected,
                event: event,
                highlightedDisplay: highlightedDisplay,
                index: index,
                isFocused: focused,
                isMobileOrTablet: isMobileOrTablet,
                setCurrentlySelected: setCurrentlySelected
            })
        });
    };
    var mobileStyles = {
        maxHeight: "300px",
        position: "fixed",
        // if not on the postform, the suggestionList modal takes up 100% of the width.
        width: isPostForm ? "".concat(calculatedSuggestionListWidth, "px") : "100%",
        left: leftStyle,
        border: "0.5px solid #CACCD6",
        borderTop: "0",
        backgroundColor: "transparent",
        paddingTop: isPhoneScreen && isPostForm && isIOS ? "60px" : "10px"
    };
    var onSearch = (0,react.useCallback)(debounce_default()(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(search, callback) {
            var users;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (search) {
                            _ctx.next = 4;
                            break;
                        }
                        {
                            callback(combinedUsers);
                        }
                        _ctx.next = 8;
                        break;
                    case 4:
                        _ctx.next = 6;
                        return handleSearch(search);
                    case 6:
                        users = _ctx.sent;
                        callback(users);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(search, callback) {
            return _ref.apply(this, arguments);
        };
    }(), 250), []);
    // shorten to only display 3 on mobile screens
    var mobileSuggestionListMaxHeight = isPhoneScreen ? "120px" : "300px";
    // shorten to fit within a single screen - no need to scroll
    var mobileMentionsTextAreaHeight = isPostForm ? "100px" : "190px";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "aria-label": t("components-mentions-keyboard_navigation_aria_label", "Mention someone. Press the up/down arrow keys to navigate. Press space/enter to select a name."),
                "aria-live": "polite",
                "aria-modal": "true",
                "data-qa": "suggestion-portal",
                id: "suggestion-portal",
                ref: function(el) {
                    container = el;
                },
                role: "dialog"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: MentionsTextArea_cx("mentions__container"),
                "data-qa": "mentions__container",
                id: id,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_mentions_esm/* MentionsInput */.r, {
                    className: MentionsTextArea_cx(textAreaClassName, additionalClassName, {
                        expanded: keepTextAreaExpanded || isExpanded || value.length
                    }),
                    "data-qa": "mentions-input",
                    inputRef: inputRef,
                    placeholder: placeholder,
                    style: {
                        suggestions: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            zIndex: 10000,
                            boxShadow: "0 12px 12px 0 rgba(0, 0, 0, 0.25)"
                        }, isMobileOrTablet ? mobileStyles : null), {
                            list: {
                                maxHeight: isMobileOrTablet ? mobileSuggestionListMaxHeight : null,
                                overflowY: isMobileOrTablet ? "scroll" : null
                            }
                        }),
                        "&multiLine": {
                            highlighter: {
                                maxHeight: isMobileOrTablet ? mobileMentionsTextAreaHeight : null,
                                overflowY: "hidden"
                            }
                        }
                    },
                    suggestionsPortalHost: container,
                    value: value,
                    allowSpaceInQuery: true,
                    allowSuggestionsAboveCursor: true,
                    onChange: onChange,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_mentions_esm/* Mention */.p, {
                        a11ySuggestionsListLabel: t("Suggested mention"),
                        className: MentionsTextArea_cx("mentions__highlight"),
                        // Data needs to be either an array of users,
                        // or a search function that is provided (search, callback)
                        // that provides a list of users via callback
                        data: onSearch,
                        displayTransform: mentions/* displayTransform */.gI,
                        markup: mentions/* markupPattern */.gj,
                        renderSuggestion: mentionsSuggestionComponent,
                        trigger: "@",
                        appendSpaceOnAdd: true,
                        onAdd: function() {
                            return setCurrentlySelected(null);
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var MentionsTextArea_MentionsTextArea = (withUsersSearch(MentionsTextArea));

;// CONCATENATED MODULE: ./components/Mentions/MentionsTextArea/index.ts



/***/ }),

/***/ 80078:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"MentionsSuggestion_sr-only--mobile__Xx0tH","sr-only":"MentionsSuggestion_sr-only__nF2JX","error-message":"MentionsSuggestion_error-message__t9t54","form-inline-edit":"MentionsSuggestion_form-inline-edit__ep1KB","form-group":"MentionsSuggestion_form-group__riPdC","form-row":"MentionsSuggestion_form-row__Ex49_","form-inline":"MentionsSuggestion_form-inline__hl5g_","error":"MentionsSuggestion_error__Uex2H","input-group-append":"MentionsSuggestion_input-group-append__zpOnn","input-group-currency":"MentionsSuggestion_input-group-currency__ezGkm","form-control":"MentionsSuggestion_form-control__aza6G","custom-select":"MentionsSuggestion_custom-select__Og2i6","is-invalid":"MentionsSuggestion_is-invalid__ZtmYW","is-valid":"MentionsSuggestion_is-valid__IMl61","input-group":"MentionsSuggestion_input-group__K2SGR","input-group-text":"MentionsSuggestion_input-group-text__rfJm5","input-group-prepend":"MentionsSuggestion_input-group-prepend__L04bq","valid-feedback":"MentionsSuggestion_valid-feedback__jQ2xJ","invalid-feedback":"MentionsSuggestion_invalid-feedback__zRivm","form-text":"MentionsSuggestion_form-text__W9E4c","label":"MentionsSuggestion_label__ZxFgz","custom-control":"MentionsSuggestion_custom-control__yOtSB","custom-control-label":"MentionsSuggestion_custom-control-label__K25Oo","custom-control-label--empty":"MentionsSuggestion_custom-control-label--empty__cLrUZ","custom-control-input":"MentionsSuggestion_custom-control-input__L85Yq","mentions-suggestion__container":"MentionsSuggestion_mentions-suggestion__container__x0Dxg","focused":"MentionsSuggestion_focused__7SxJu","active":"MentionsSuggestion_active__Biq1W","mobile":"MentionsSuggestion_mobile__2_HQ1","mentions-suggestion__avatar-container":"MentionsSuggestion_mentions-suggestion__avatar-container__mCOyL","mentions-suggestion__avatar":"MentionsSuggestion_mentions-suggestion__avatar__l4o3P","Avatar_avatar__initials":"MentionsSuggestion_Avatar_avatar__initials__tJwHk","mentions-suggestion__user":"MentionsSuggestion_mentions-suggestion__user__ZYIZN","mentions-suggestion__user__name":"MentionsSuggestion_mentions-suggestion__user__name___tNhv"};

/***/ }),

/***/ 69690:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"MentionsTextArea-x_sr-only--mobile__Ign_C","sr-only":"MentionsTextArea-x_sr-only__PJdxO","error-message":"MentionsTextArea-x_error-message__bgERG","form-inline-edit":"MentionsTextArea-x_form-inline-edit__9vbwG","form-group":"MentionsTextArea-x_form-group__PIy6m","form-row":"MentionsTextArea-x_form-row__Ch5K4","form-inline":"MentionsTextArea-x_form-inline__Kvps_","error":"MentionsTextArea-x_error__FEx70","input-group-append":"MentionsTextArea-x_input-group-append__DJnCx","input-group-currency":"MentionsTextArea-x_input-group-currency__GDhng","form-control":"MentionsTextArea-x_form-control__8JLCp","custom-select":"MentionsTextArea-x_custom-select__L5X9y","is-invalid":"MentionsTextArea-x_is-invalid__Wh6SC","is-valid":"MentionsTextArea-x_is-valid__ewMPQ","input-group":"MentionsTextArea-x_input-group__f0yDH","input-group-text":"MentionsTextArea-x_input-group-text__PRatD","input-group-prepend":"MentionsTextArea-x_input-group-prepend__qcz8h","valid-feedback":"MentionsTextArea-x_valid-feedback__ypb_8","invalid-feedback":"MentionsTextArea-x_invalid-feedback__U_6bT","form-text":"MentionsTextArea-x_form-text__7f8Gz","label":"MentionsTextArea-x_label__ctQXh","custom-control":"MentionsTextArea-x_custom-control__Ffb5s","custom-control-label":"MentionsTextArea-x_custom-control-label__Un9bA","custom-control-label--empty":"MentionsTextArea-x_custom-control-label--empty___gHtR","custom-control-input":"MentionsTextArea-x_custom-control-input__hotLh","mentions__container":"MentionsTextArea-x_mentions__container__TMk0D","mentions__text-area":"MentionsTextArea-x_mentions__text-area__1OaP1","post-form__modal":"MentionsTextArea-x_post-form__modal__vzicx","post__feed":"MentionsTextArea-x_post__feed__Bj_uC","post__detail":"MentionsTextArea-x_post__detail__M_fxG","comment__detail":"MentionsTextArea-x_comment__detail__lEsLP","reply__detail":"MentionsTextArea-x_reply__detail__4GBe5","expanded":"MentionsTextArea-x_expanded__sP6PN","add-comment__modal":"MentionsTextArea-x_add-comment__modal__xaK38","edit-comment__modal":"MentionsTextArea-x_edit-comment__modal__u_2ZA","add-reply__modal":"MentionsTextArea-x_add-reply__modal__A2OJQ","mentions__highlight":"MentionsTextArea-x_mentions__highlight__DtgKx"};

/***/ })

}]);